import React from 'react';

const bubbles = [
  { size: 300, top: '-80px', left: '-60px', delay: 0, duration: 8, opacity: 0.08 },
  { size: 200, top: '10%', left: '75%', delay: 1.5, duration: 11, opacity: 0.07 },
  { size: 140, top: '25%', left: '5%', delay: 0.5, duration: 7, opacity: 0.09 },
  { size: 80, top: '40%', left: '88%', delay: 2, duration: 6, opacity: 0.1 },
  { size: 60, top: '55%', left: '40%', delay: 1, duration: 9, opacity: 0.06 },
  { size: 180, top: '60%', left: '-40px', delay: 3, duration: 12, opacity: 0.07 },
  { size: 100, top: '75%', left: '65%', delay: 0.8, duration: 8, opacity: 0.08 },
  { size: 50, top: '80%', left: '25%', delay: 2.5, duration: 7, opacity: 0.1 },
  { size: 240, top: '85%', left: '80%', delay: 1.2, duration: 10, opacity: 0.06 },
  { size: 70, top: '15%', left: '50%', delay: 3.5, duration: 8, opacity: 0.07 },
  { size: 120, top: '45%', left: '55%', delay: 0.3, duration: 9, opacity: 0.05 },
  { size: 90, top: '30%', left: '30%', delay: 4, duration: 7, opacity: 0.06 },
];

export default function FloatingBubbles() {
  return (
    <>
      <style>{`
        @keyframes bubbleFloat {
          0%, 100% { transform: translateY(0px) scale(1); }
          33% { transform: translateY(-18px) scale(1.03); }
          66% { transform: translateY(-8px) scale(0.98); }
        }
      `}</style>
      <div style={{
        position: 'fixed',
        top: 0, left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 0,
        overflow: 'hidden'
      }}>
        {bubbles.map((b, i) => (
          <div key={i} style={{
            position: 'absolute',
            width: `${b.size}px`,
            height: `${b.size}px`,
            borderRadius: '50%',
            background: `rgba(99, 179, 237, ${b.opacity})`,
            top: b.top,
            left: b.left,
            animation: `bubbleFloat ${b.duration}s ease-in-out ${b.delay}s infinite`,
            border: `1px solid rgba(43, 108, 176, ${b.opacity * 0.6})`,
          }} />
        ))}
      </div>
    </>
  );
}
